import { createRouter, createWebHistory } from 'vue-router'
import BlogPage from '@/blog/BlogPage'
import BlogPost from '@/blog/BlogPost'
import SubscribePage from '@/blog/SubscribePage'
import ProjectsPage from '@/portfolio/ProjectsPage'
import AboutPage from '@/portfolio/AboutPage'
import OnboardingTool from '@/onboarding/OnboardingTool'
import RequestProject from '@/onboarding/RequestProject'
import ProjectCatalog from '@/onboarding/ProjectCatalog'
import SubscriptionConfirm from '@/generic/SubscriptionConfirm'
import SubscriptionThankYou from '@/generic/SubscriptionThankYou'
import NotFound from '@/generic/NotFound'
import PrivacyPolicy from '@/generic/PrivacyPolicy'
import TermsOfUse from '@/generic/TermsOfUse'
import HomePage from '@/generic/HomePage'
import ContactPage from '@/generic/ContactPage'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomePage
    },
    {
      path: '/blog',
      name: 'Blog',
      component: BlogPage
    },
    {
      path: '/blog/:filename',
      name: 'Blogpost',
      component: BlogPost
    },
    {
      path: '/subscribe',
      name: 'SubscribePage',
      component: SubscribePage
    },
    {
      path: '/side-projects',
      name: 'Projects',
      component: ProjectsPage
    },
    {
      path: '/about',
      name: 'About',
      component: AboutPage
    },
    {
      path: '/project-quotation-ai',
      name: 'OnboardingTool',
      component: OnboardingTool
    },
    {
      path: '/project-catalog',
      name: 'ProjectCatalog',
      component: ProjectCatalog
    },
    {
      path: '/project-quotation-ai/request/uuid/:uuid',
      name: 'RequestProject',
      component: RequestProject
    },
    {
      path: '/confirm-your-subscription',
      name: 'SubscriptionConfirm',
      component: SubscriptionConfirm
    },
    {
      path: '/thanks-for-subscribing',
      name: 'SubscriptionThankYou',
      component: SubscriptionThankYou
    },
    {
      path: '/terms',
      name: 'TermsOfUse',
      component: TermsOfUse
    },
    {
      path: '/privacy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '/contact',
      name: 'ContactPage',
      component: ContactPage
    },
    {
      path: '/:pathMatch(.*)*',
      name: '404',
      component: NotFound
    }
  ]
})
export default router
